import React from "react";

const YoutubeIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="18.134" height="13.599" viewBox="0 0 18.134 13.599"><path d="M9.085,13.6c-2.327,0-4.485-.052-5.772-.139A2.794,2.794,0,0,1,.56,11.807,14.021,14.021,0,0,1,0,6.8,14,14,0,0,1,.562,1.789,2.8,2.8,0,0,1,3.315.139C4.6.052,6.751,0,9.079,0s4.468.052,5.742.139a2.794,2.794,0,0,1,2.753,1.653,14.025,14.025,0,0,1,.56,5.008,14,14,0,0,1-.562,5.01,2.8,2.8,0,0,1-2.752,1.65C13.547,13.547,11.4,13.6,9.085,13.6ZM6.8,3.777h0V9.822l6.044-3.029L6.8,3.777Z" fill={props.fill}/></svg>
    )
}

export default YoutubeIcon;
